export enum AccountingBasis {
  CASH = 'CASH',
  ACCRUAL = 'ACCRUAL',
}

export enum AccountingFrequency {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

// TODO: Need to finalize if this is correct. Copied from frontend.
export enum BusinessPurposeEnum {
  ACCOMMODATIONS = 'ACCOMMODATIONS',
  CONSTRUCTION = 'CONSTRUCTION',
  FINANCE = 'FINANCE',
  FOOD_SERVICE = 'FOOD_SERVICE',
  HEALTH_CARE = 'HEALTH_CARE',
  INSURANCE = 'INSURANCE',
  REAL_ESTATE = 'REAL_ESTATE',
  RENTAL_LEASING = 'RENTAL_LEASING',
  RETAIL = 'RETAIL',
  SOCIAL_ASSISTANCE = 'SOCIAL_ASSISTANCE',
  TRANSPORTATION = 'TRANSPORTATION',
  WAREHOUSING = 'WAREHOUSING',
  WHOLESALE = 'WHOLESALE',
  CONSULTING = 'CONSULTING',
  MANUFACTURING = 'MANUFACTURING',
  ORGANIZATION = 'ORGANIZATION',
  RENTAL = 'RENTAL',
  REPAIR = 'REPAIR',
  SELL_GOODS = 'SELL_GOODS',
  SERVICE = 'SERVICE',
  SOFTWARE_SERVICES = 'SOFTWARE_SERVICES',
  OTHER = 'OTHER',
}

export enum CorporationOnboardingStages {
  COMPANY_INFORMATION = 'COMPANY_INFORMATION',
  CONTACT_INFORMATION = 'CONTACT_INFORMATION',
  FINANCIAL_INFORMATION = 'FINANCIAL_INFORMATION',
  EMPLOYEE_INFORMATION = 'EMPLOYEE_INFORMATION',
  BUSINESS_ACTIVITIES = 'BUSINESS_ACTIVITIES',
  RELATIONSHIPS_WITH_OTHER_CORPORATIONS = 'RELATIONSHIPS_WITH_OTHER_CORPORATIONS',
  LEGAL_DOCUMENTS = 'LEGAL_DOCUMENTS',
  COMPLIANCE_AND_REGULATIONS = 'COMPLIANCE_AND_REGULATIONS',
  SHAREHOLDER_AND_DIRECTORS_INFORMATION = 'SHAREHOLDER_AND_DIRECTORS_INFORMATION',
  AUTHORIZED_SIGNATORY = 'AUTHORIZED_SIGNATORY',
  ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION',
  FINISHED_ONBOARDING = 'FINISHED_ONBOARDING',
  POST_ONBOARDING = 'POST_ONBOARDING',
  STAKEHOLDER_INFORMATION = 'STAKEHOLDER_INFORMATION',
  STAKEHOLDER_ROLES = 'STAKEHOLDER_ROLES',
}

export enum Marketplace {
  Shopify = 'Shopify',
  Amazon = 'Amazon',
  Walmart = 'Walmart',
  eBay = 'eBay',
  Etsy = 'Etsy',
  Quickbooks = 'Quickbooks',
  NetSuite = 'NetSuite',
  Sellercloud = 'Sellercloud',
  Stripe = 'Stripe',
  Other = 'Other',
  None = 'None',
}

// Additional Information Data (extended from entity management sheet)
export enum TaxClassificationEntityTypeEnum {
  C_CORPORATION = 'C_CORPORATION',
  S_CORPORATION = 'S_CORPORATION',
  PARTNERSHIP = 'PARTNERSHIP',
  INDIVIDUAL_OR_SOLE_PROPRIETORSHIP = 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP',
  DISREGARDED_ENTITY = 'DISREGARDED_ENTITY',
  FOREIGN_CORPORATION = 'FOREIGN_CORPORATION',
  FOREIGN_PARTNERSHIP = 'FOREIGN_PARTNERSHIP',
}

// Sales Tax Onboarding Information -- not needed. Not being used in Sales Tax. Miliek confirmed.
// export enum Industries {
//   Renting = "Renting",
//   Leasing = "Leasing",
//   Service = "Service",
//   Cannabis = "Cannabis",
//   Utilities = "Utilities",
//   Fuel = "Fuel",
//   "Beer, wine, liquor" = "Beer, wine, liquor",
//   "None of the above" = "None of the above",
// }
// Only need industry for india incorporation.
export enum IndustryOptions {
  Agriculture = 'Agriculture',
  Aerospace = 'Aerospace',
  Construction = 'Construction',
  Transportation = 'Transportation',
  Healthcare = 'Healthcare',
  Education = 'Education',
  Manufacturing = 'Manufacturing',
  NewsMedia = 'News Media',
  Technology = 'Technology',
  Software = 'Software',
  Mining = 'Mining',
  Entertainment = 'Entertainment',
  Finance = 'Finance',
  FoodProcessing = 'Food Processing',
  HeavyIndustry = 'Heavy industry',
  Hospitality = 'Hospitality',
  Pharmaceutical = 'Pharmaceutical',
  Telecommunication = 'Telecommunication',
  Other = 'Other',
}

export enum TaxAndAccountingOnboardingStages {
  REVIEW_ENTITY_DETAILS = 'REVIEW_ENTITY_DETAILS',
  VIEW_COMPLIANCE_CALENDAR = 'VIEW_COMPLIANCE_CALENDAR',
  SELECT_COMPLIANCE_METHOD = 'SELECT_COMPLIANCE_METHOD',
  SELECT_DEFAULT_ASSIGNEE = 'SELECT_DEFAULT_ASSIGNEE',
}

export type TaxAndAccountingOnboardingInformation = {
  currentStage?: TaxAndAccountingOnboardingStages;
  stagesOfCorporationOnboardingProcessesFinished?: TaxAndAccountingOnboardingStages[];
};

export enum MCQTypes {
  Yes = 'Yes',
  No = 'No',
  Maybe = 'Maybe',
}

/**
 * How ownership is held.
 *
 * The backend's vocabulary, not Prisma's — it is stored as text there so entity-management can
 * curate it without a migration. A label to display and key by; what it *means* (whether units
 * are tracked, whether a second class can exist, which words to print) arrives as answers on
 * the entity's ownership and in ownershipVocabulary, so nothing here should branch on it.
 */
export type HoldingType = 'SHARES' | 'MEMBERSHIP' | 'PARTNERSHIP';
